import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import styles from './TagsList.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import { Tag } from './Tag/Tag'
import AddEditTagModal from '../../../ContentBox/Global/GlobalModalSingle/templates/CRM/AddEditTagModal/AddEditTagModal'

export const TagsList = () => {
  const [tags, setTags] = useState([])

  const fetchTags = () => {
    superAxiosRequest({
      link: `integration/tags`,
      method: 'get',
      crm: true,
    })
      .then(({ data }) => {
        setTags(data.result)
      })
      .catch((error) => {
        console.error('Ошибка загрузки тегов:', error)
      })
  }

  useEffect(() => {
    fetchTags()
  }, [])

  const addTag = () => {
    const ms = {
      modalBodyComponent: () => <AddEditTagModal />,
      button: 'Save',
      link: 'integration/tags',
      title: 'Add a tag',
      isCenter: true,
      crm: true,
      onBeforeSubmit: (formData) => {
        return {
          name: formData.name,
        }
      },
      onSubmitSuccess: () => {
        fetchTags()
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms)
  }

  const editTag = (tag) => {
    const ms = {
      modalBodyComponent: () => (
        <AddEditTagModal edit initialValue={tag?.name} />
      ),
      button: 'Сохранить',
      link: `integration/tags/${tag.id}`,
      is_put: true,
      title: 'Edit the tag',
      isCenter: true,
      crm: true,
      onBeforeSubmit: (formData) => {
        return {
          name: formData.name,
        }
      },
      onSubmitSuccess: () => {
        fetchTags()
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms)
  }

  const deleteTag = (tagId) => {
    swal({
      title: 'Вы уверены?',
      text: 'После удаления тег нельзя будет восстановить.',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Отмена',
          value: null,
          visible: true,
        },
        confirm: {
          text: 'Удалить',
          value: true,
          className: 'swal-button--danger',
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        superAxiosRequest({
          link: `integration/tags/${tagId}`,
          method: 'delete',
          crm: true,
        })
          .then(() => {
            swal('Успешно!', 'Тег был удален.', 'success')
            fetchTags()
          })
          .catch((error) => {
            swal('Ошибка!', 'Не удалось удалить тег.', 'error')
            console.error('Ошибка удаления:', error)
          })
      }
    })
  }

  const action = (actionType, e, items) => {
    const actions = new Map([
      ['edit_tag', () => editTag(items)],
      ['delete_tag', () => deleteTag(items?.id)],
    ])
    return actions.get(actionType)?.()
  }

  const menu = [
    { name: 'Редактировать', action: 'edit_tag' },
    { name: 'Удалить', action: 'delete_tag' },
  ]

  return (
    <div className={styles.tagsContainer}>
      <div className={styles.header}>
        <PageHeader title={'Теги'} />
        <div className={styles.settingsLocalization__box}>
          <HeaderAddButton title={'Добавить тег'} onClick={addTag} />
        </div>
      </div>
      {tags.length === 0 ? (
        <div className={styles.noReasons}>There are no added tags</div>
      ) : (
        tags.map((tag, index) => (
          <Tag
            key={tag.id + index + tag.name}
            type={tag}
            action={action}
            index={index}
            menu={menu}
          />
        ))
      )}
    </div>
  )
}
